import './main.css'

import { LoadingOutlined } from '@ant-design/icons';
import { Space, Spin } from 'antd';
import { useLocation,useNavigate  } from "react-router-dom";

import callAPI from '../../comps/fetch/main'
import { useEffect, useState } from 'react';


function SPRDR(){

    
    const [loading, setLoading] = useState()
    const [data, setData] = useState({})
    const [shopData, setShopData] = useState({})

    const [error, setError] = useState()

    const navigate = useNavigate();
    
    let url = window.location.href
    // const queryParams = new URLSearchParams(url.split('#')[1]);

    useEffect(() => {

        if(data?.code == 200){
            // let token =  data["data"]?.["token"]
            // localStorage.setItem("token" , token)
            // localStorage.removeItem("refCode")
            // navigate('/shopify')
            // redirect to "https://admin.shopify.com/apps/instantdm"
            window.location.href = "https://admin.shopify.com/apps/instantdm";
        }

        if(data?.code !=undefined && (data?.code != 200 || data?.code != "200") ){
            setError("Sorry, That didn't work, try again after sometime.")
            setTimeout(() => {
                window.location.href = "https://admin.shopify.com/apps/instantdm";
            }, 2500)
            return
        }

        

    } , [data])

    useEffect(() => {
        if(loading == true){
            return
        }
        const url = new URL(window.location.href);
   
        const code = url.searchParams.get('code');
        const shop =  url.searchParams.get('shop');
             setShopData({
            code, shop
        })
  
        // return
        callAPI({url:"shopify-store-connect", method: "POST", body : {
            code,
            shop
        } , loadingState:setLoading ,  dataState:setData}  )
        
    } , [])



    return(
        <div className='fb-rdr'>
           { !error &&  <p><Spin indicator={<LoadingOutlined spin />} style={{marginRight:'10px'}} /> Please wait we're valiating your request.</p> }
           <p>{shopData.shop}</p>
           <p>{shopData.code}</p>
           {error && <p style={{color:'red'}}>{error}</p>}
        </div>
    )
}
export default SPRDR;